var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngularjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 70,
    viewBox: "0 0 67 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9342 0L0 11.5901L5.20413 54.7398L32.9691 70L60.8772 54.5329L66.0796 11.385L32.9342 0Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7931 13.8782L32.8555 3.66935V66.3535L57.9446 52.4685L62.7931 13.8782Z",
    fill: "#AF2B2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69531 14.0626L8.1548 52.6527L32.8566 66.3535V3.66813L3.69531 14.0626Z",
    fill: "#DF2E31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7982 34.8482L32.9135 20.4709L26.8526 34.8482H39.7982ZM42.4232 40.8937H24.1733L20.0906 51.1057L12.4961 51.2461L32.8591 5.9464L53.9319 51.2461H46.893L42.4232 40.8937Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8555 5.94664L32.9098 20.4711L39.7874 34.8595H32.871L32.8555 40.8845L42.4192 40.8939L46.8893 51.248L54.156 51.3828L32.8555 5.94664Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularjs);
export default __webpack_public_path__ + "static/media/angularjs.35265051a3424044d81b6eaff070ec11.svg";
export { ForwardRef as ReactComponent };